import { useCategoryPageQuery } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useCategoryPageQuery/useCategoryPageQuery";
export var useIsCategoryPageLoading = function() {
    var _useCategoryPageQuery = useCategoryPageQuery(), isFetching = _useCategoryPageQuery.isFetching, data = _useCategoryPageQuery.data;
    return isFetching || data === undefined; // data === undefined accounts for disabled query
};
export var useCategoryPageDataUpdatedAt = function() {
    var dataUpdatedAt = useCategoryPageQuery().dataUpdatedAt;
    return dataUpdatedAt;
};
